import http from "../http";

const AutoPermissionService = {

    addAutoPermissionService: async (value) => {
        const addp = await http.instance.post("roles/autopermission/" + value);
        return addp.data;
    },


};
export default AutoPermissionService;
